import { React, useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import { apiUrl,cdnUrl, cdnParams } from '../Helpers/General';

import Home from '../PagesClaude/home';
import Gallery from '../PagesClaude/gallery';
import Shop from '../PagesClaude/shop';
import About from '../PagesClaude/about';
import Nav from '../PagesClaude/nav';
import Footer from '../PagesClaude/footer';
import Lightbox from '../PagesClaude/lightbox';



/**
 * 	home heros 
 *      - gallery slug: "home-hero-gallery"
 *  home latest 
 *      - gallery slug: "home-latest-gallery"
 *  edition (shop) images 
 *      - all images from type=gallery that have pricings.price > 0 && pricings.buyLink set
 *  gallery images 
 *      - all images from all items with type=gallery
 *  studio stories : 
 *      - all items from type=blog
 */

const pagesSlugs = [   
    "header",
    "footer",
    "home",
    "editions",
    "gallery",
    "studio"
];

const navItems = [
    { id: "home", label: "Home" },
    { id: "shop", label: "Shop" },
   // { id: "gallery", label: "Archive" },
    { id: "about", label: "Studio" },
];





const MainClaude = () => {
    const [route, setRoute] = useState("home");
    const [apiData, setApiData] = useState(null);
    const [lightboxId, setLightboxId] = useState(null);
    const [lightboxImages, setLightboxImages] = useState([]);
    
    const openLightbox = useCallback((id,images) => {
        setLightboxId(id);
        setLightboxImages(images);
    }, []);
    const closeLightbox = useCallback(() => {
        setLightboxId(null);
        setLightboxImages([]);
    }, []);
    
    useEffect(() => {
        getApiData();
        document.documentElement.setAttribute("data-theme", "paper");
    // eslint-disable-next-line
    }, []);

    const navLightbox = useCallback(
        (dir) => {
            const archive = lightboxImages;
            const i = lightboxImages.findIndex((p) => p.id === lightboxId);
            if (i < 0) return;
            const n = (i + dir + archive.length) % archive.length;
            setLightboxId(archive[n].id);
        },
        [lightboxImages, lightboxId]
    );

    const getApiData = () => {
        axios.get(`${apiUrl}api/items?media=1&categories=1&isActive=1`)
        .then(res => res.data)
        .then(apiData => {

            let newData = {
                pages:      [],
                images:     [],
                shop:       [],
                blog:       []
            };

            // pages
            pagesSlugs.forEach(k => {
                let pages = apiData.filter(x => x.type==="page" && x.slug.includes(`${k}-`));
                pages.forEach((page,pageIdx) => {
                    pages[pageIdx].dataJson = getJsonData(page.data);
                    pages[pageIdx].mediaNew = [];
                    page.media.forEach((mediaItem,mediaIdx) => {
                        mediaItem.cdnUrl = getImageCdnUrl(page.id, mediaItem.data);
                        mediaItem.pricingsJson = getJsonData(mediaItem.pricings);
                        if( mediaItem?.pricingsJson?.active === "1" ){
                            pages[pageIdx].mediaNew.push(mediaItem);
                        }
                    })
                })
                newData.pages[k] = pages;
            })

            // imagea gallery + shop
            apiData
                .filter(x => x.type==="gallery" && x.isActive === "1")
                .forEach( k => {
                    k.dataJson = getJsonData(k.data);
                    //console.log(k.dataJson);
                    k.media.forEach( m => {

                        // general images
                        m.cdnUrl = getImageCdnUrl(k.id, m.data);
                        m.date_content = k.date_content;
                        m.title = k.title;
                        m.pricingsJson = getJsonData(m.pricings);
                        m.country = k.dataJson.country;
                        newData.images.push(m);

                        // shop images
                        if( parseInt(m.pricingsJson.price) > 0 
                            && m.pricingsJson.buyUrl !== '' 
                            && m.pricingsJson.active === "1"
                        ){
                            newData.shop.push(m);
                        }
                    });
                });

            // blog entries
            apiData
                .filter(f => f.type==="blog" && f.isActive === "1" )
                .forEach( blogItem => {
                    console.log(blogItem);
                    blogItem.jsonData = getJsonData(blogItem.data);
                    blogItem.mediaNew = [];
                    blogItem.media.forEach( s => {
                        s.cdnUrl = getImageCdnUrl(blogItem.id, s.data);;
                        s.pricingsJson = getJsonData(s.pricings);
                        blogItem.mediaNew.push(s);
                    });
                    newData.blog.push(blogItem);
                });

            // set data
            setApiData(newData)
        });
    }

    const getJsonData = ( jsonString ) => {
        let dataJson = {}
        if( jsonString !== undefined && jsonString !== null && jsonString !== "" ){
            try {
                dataJson = JSON.parse(jsonString);
            } catch (err) {
                console.log(err);
            }
        }
        return (dataJson?.[1] !== undefined ) 
            ? dataJson[1] 
            : dataJson;
    }
    
    const getImageCdnUrl = (id, path) => {
        return `${cdnUrl}item/${id}/${path}${cdnParams}`;
    }

    
    
    const Page = useMemo(() => {

        const getGalleryFilters = () => {

            let islands = ["All"];
            apiData.images.forEach( x => {
                if( x.title !== undefined 
                    && x.title !== ''
                    && islands.includes(x.title) === false 
                ){
                    islands.push(x.title);
                }
            });

            let years = ["All"];
            apiData.images.forEach( y => {
                if( y?.date_content !== undefined 
                    && y.date_content !== ''
                    && years.includes(y.date_content.split('-')[2]) === false 
                ){
                    years.push(y.date_content.split('-')[2]);
                }
            });

            let countries = ["All"];
            apiData.images.forEach( z => {
                if( z?.country !== undefined 
                    && z.country !== ''
                    && countries.includes(z.country) === false 
                ){
                    countries.push(z.country);
                }
            });

            return {
                islands: islands,
                years: years,
                countries: countries,
            };
        }

        switch (route) {
            case "home":
                return <Home 
                    setRoute={setRoute} 
                    openLightbox={openLightbox} 
                    pages={apiData?.pages.home}
                />;
            case "shop":
                return <Shop 
                    openLightbox={openLightbox} 
                    images={apiData?.shop}
                    pages={apiData?.pages.editions}
                />;
            case "gallery":
                return <Gallery 
                    openLightbox={openLightbox} 
                    images={apiData?.images} 
                    pages={apiData?.pages.gallery}
                    filters={getGalleryFilters()}
                />;
            case "about":
                return <About 
                    openLightbox={openLightbox} 
                    blog={apiData?.blog}
                    pages={apiData?.pages.studio}
                />;
            default:
                return <Home setRoute={setRoute} openLightbox={openLightbox} />;
        }
    }, [
        apiData,
        route, 
        openLightbox,
    ]);
    


    return (

        <div className="wi-app" data-screen-label={`Winter Islands — ${route}`}>

            { apiData == null && 
                <div key={route} className="wi-page wi-page-enter">
                    loading
                </div>
            }

            { apiData !== null && 
                <>
                    <Nav 
                        navItems={navItems}
                        pages={apiData?.pages?.header} 
                        route={route} 
                        setRoute={setRoute} 
                        theme={"paper"} 
                    />

                    <div 
                        key={route} 
                        className="wi-page wi-page-enter"
                    >
                        {Page}
                    </div>

                    <Footer 
                        pages={apiData?.pages?.footer} 
                        route={route} 
                        navItems={navItems}
                        setRoute={setRoute}  
                    />
                
                    {lightboxId && (
                        <Lightbox
                            id={lightboxId}
                            items={lightboxImages}
                            route={route}
                            onClose={closeLightbox}
                            onNav={navLightbox}
                        />
                    )}
                </>
            }
        
        </div>
    );
};

export default MainClaude;
